import angular from 'angular';

class NgCaseDirective {

    constructor() {
        this.priority = 1200;
        this.transclude = 'element';
        this.require = '^ngSwitch';
    }

    static factory() {
        'ngInject';
        return new NgCaseDirective();
    }
    link(scope, element, attrs, ngSwitch, $transclude) {
        let cases = scope.$eval(attrs.ngCase);
        cases = angular.isArray(cases) ? cases : [cases];

        cases.forEach(c => {
            c = '!' + c;
            ngSwitch.cases[c] = ngSwitch.cases[c] || [];
            ngSwitch.cases[c].push({ transclude: $transclude, element: element });
        });
    }
}

// Explicit DI annotation for factory used in angular.directive registration
NgCaseDirective.factory.$inject = [];

export default NgCaseDirective.factory;
